import { useEffect, useState, useRef } from 'react';

export const useScrollableArrows = (itemWidth: number = 200) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
        setShowLeftArrow(scrollLeft > 0);
        setShowRightArrow(scrollLeft + clientWidth < scrollWidth);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    containerRef.current?.addEventListener('scroll', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
      containerRef.current?.removeEventListener('scroll', checkOverflow);
    };
  }, []);

  const scroll = (direction: 'left' | 'right') => {
    if (containerRef.current) {
      const scrollAmount = direction === 'left' ? -itemWidth : itemWidth;
      containerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return { containerRef, showLeftArrow, showRightArrow, scroll };
};
